// extracted by mini-css-extract-plugin
module.exports = {"main":"AnimalDetailItem_main__mh6UC","label":"AnimalDetailItem_label__1qpxd","value":"AnimalDetailItem_value__nvrH6"};